import { Button, CardActions, CardContent, FormControl, Input, InputLabel } from '@mui/material';
import React, { useState, useContext } from 'react';
import DailyResult from '../../types/api/DailyResult';
import { AppContext } from '../../context/appContext';
import dayjs from 'dayjs';

interface DailyResultsProps {
    baseValue: DailyResult | null | undefined,
    mode: 'add' | 'edit' | 'delete',
    no: ()=>void,
    yes: (dailyResult: DailyResult)=>void
}

function verifyDailyResult(dailyResult: DailyResult): boolean {
    if (dailyResult.noonPerformance < 0 || dailyResult.eveningPerformance < 0) {
        return false;
    }
    if (dailyResult.noonTurnover < 0 || dailyResult.eveningTurnover < 0) {
        return false;
    }
    return true;
}
export function DailyResults(DailyResultsProps: DailyResultsProps) {
    const today = dayjs();
    const appContext = useContext(AppContext);
    const [dailyResult, setDailyResult] = useState(
        {
            id: -1, 
            dayOfTheWeek: DailyResultsProps.baseValue?.dayOfTheWeek ?? today.get('day'),
            dayNumber: DailyResultsProps.baseValue?.dayNumber ?? today.date(),
            month: DailyResultsProps.baseValue?.month ?? today.month(),
            year: DailyResultsProps.baseValue?.year ?? today.year(),
            eveningPerformance: DailyResultsProps.baseValue?.eveningPerformance ?? 0,
            eveningTurnover: DailyResultsProps.baseValue?.eveningTurnover ?? 0,
            noonPerformance: DailyResultsProps.baseValue?.noonPerformance ?? 0,
            noonTurnover: DailyResultsProps.baseValue?.noonTurnover ?? 0
        } as DailyResult);
    return (
        <div >
            <h1 className='bg-black text-white p-8 sm:p-6 md:p-4 font-bold'>Saisir les résultats du jour :</h1>

            <CardContent className='flex flex-col gap-4'>
                <div className='flex flex-row gap-8'>
                    <FormControl variant="standard">
                        <InputLabel htmlFor="employee-hours">Couverts du midi :</InputLabel>
                        <Input
                            error={dailyResult.noonPerformance < 0 }
                            id="employee-hours"
                            type="number"
                            value={dailyResult.noonPerformance}
                            onChange={(data: React.ChangeEvent<HTMLInputElement>) => {
                                setDailyResult({...dailyResult, noonPerformance: parseInt(data.target.value)})
                            }}
                            aria-describedby="employee-hours-text"
                        />
                    </FormControl>

                    <FormControl variant="standard">
                        <InputLabel htmlFor="employee-hours">Couverts du soir :</InputLabel>
                        <Input
                            error={dailyResult.eveningPerformance < 0 }
                            id="employee-hours"
                            type="number"
                            value={dailyResult.eveningPerformance}
                            onChange={(data: React.ChangeEvent<HTMLInputElement>) => {
                                setDailyResult({...dailyResult, eveningPerformance: parseInt(data.target.value)})

                            }}
                            aria-describedby="employee-hours-text"
                        />
                    </FormControl>
                </div>

                <div className='flex justify-center'>
                    Couverts du jour : <span className='font-bold'>{dailyResult.noonPerformance + dailyResult.eveningPerformance}</span>
                </div>

                <div className='flex flex-row gap-8'>
                <FormControl variant="standard">
                        <InputLabel htmlFor="employee-hours">CA du midi :</InputLabel>
                        <Input
                            error={dailyResult.noonTurnover < 0 }
                            id="employee-hours"
                            type="number"
                            value={dailyResult.noonTurnover}
                            onChange={(data: React.ChangeEvent<HTMLInputElement>) => {
                                setDailyResult({...dailyResult, noonTurnover: parseInt(data.target.value)})
                            }}
                            aria-describedby="employee-hours-text"
                        />
                    </FormControl>

                    <FormControl variant="standard">
                        <InputLabel htmlFor="employee-hours">CA du soir :</InputLabel>
                        <Input
                            error={dailyResult.eveningTurnover < 0 }
                            id="employee-hours"
                            type="number"
                            value={dailyResult.eveningTurnover}
                            onChange={(data: React.ChangeEvent<HTMLInputElement>) => {
                                setDailyResult({...dailyResult, eveningTurnover: parseInt(data.target.value)})
                            }}
                            aria-describedby="employee-hours-text"
                        />
                    </FormControl>
                </div>
                <div className='flex justify-center'>
                    CA du jour : <span className='font-bold'>{dailyResult.noonTurnover + dailyResult.eveningTurnover}</span>
                </div>
            </CardContent>
            <CardActions className='justify-between'>
                <Button size="small" color='error' onClick={DailyResultsProps.no}>Annuler</Button>
                <Button size="small" color='info' onClick={()=>{
                    if (!verifyDailyResult(dailyResult)) {
                        appContext.showSnackbar('Vous ne pouvez pas valider des nombres négatifs !', 'error');
                        return;
                    }
                    DailyResultsProps.yes(dailyResult)
                    }}>
                    Valider
                </Button>
            </CardActions>
        </div>
    );
}

export default DailyResults;